import React, { Component } from 'react';
import LoginButton from './LoginButton';
import RegisterButton from './RegisterButton';
import ForgotPasswordButton from './ForgotPasswordButton';

class LoginFlow extends Component {
    state = {  }
    render() {
        return (
            <div>
                <LoginButton />
                <RegisterButton />
                <ForgotPasswordButton />
            </div>
        );
    }
}

export default LoginFlow;